import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch } from 'antd';

export const LanguageEdit: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'languages' });

  return (
    <Edit resource="languages" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Code" name="code" rules={[{ required: true }]}>
          <Input placeholder="e.g. ja-JP" />
        </Form.Item>
        <Form.Item label="Label" name="label" rules={[{ required: true }]}>
          <Input placeholder="e.g. 日本語" />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="Sort Order" name="sortOrder">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
